import { FlightDetailModalState, GalleryModalState, InternalChatState, ReelsModalState } from 'types';
import { Fragment, h } from '@stencil/core';
import FeedbackModal from './FeedbackModal';
import FeedbackFormModal from './FeedbackFormModal';
import DistributionModal from './DistributionModal';
import VideoPlayerModal from './VideoPlayerModal';
import ViewMoreModal from './ViewMoreModal';
import RecoverChatModal from './RecoverChatModal';
import GalleryModal from './GalleryModal';
import DebugModal from './DebugModal';
import FlightDetailModal from './FlightDetailModal';
import CDCModal from './CDCModal';
import VoiceModal from './VoiceModal';

interface ModalsProps {
  store: InternalChatState;
  reelsModal: ReelsModalState;
  galleryModal: GalleryModalState;
  flightDetailModal: FlightDetailModalState;
}

export default function Modals({ reelsModal, store, galleryModal, flightDetailModal }: ModalsProps) {
  return (
    <Fragment>
      <FeedbackModal show={store.showFullScreenModal === 'FEEDBACK'} />
      <DebugModal show={store.showFullScreenModal === 'DEBUG'} />
      <FeedbackFormModal />
      <DistributionModal show={store.showFullScreenModal === 'DISTRIBUTION'} />
      <VideoPlayerModal show={reelsModal.isOpen} />
      <ViewMoreModal show={store.showFullScreenModal === 'FAQS_VIEW_MORE'} />
      <RecoverChatModal show={store.showFullScreenModal === 'RECOVER_CHAT'} />
      <VoiceModal show={store.showFullScreenModal === 'VOICE'} />
      <GalleryModal show={galleryModal.isOpen} />
      <FlightDetailModal show={flightDetailModal.isOpen} />
      <CDCModal show={store.showFullScreenModal === 'CONTACT_CENTER'} />
    </Fragment>
  );
}
